import { NumberUtilities } from "../utilities/number-utilities";
import moment from "moment";
var DateTimeHelper = /** @class */ (function () {
    function DateTimeHelper() {
    }
    DateTimeHelper.getUtcNow = function () {
        var now = new Date();
        return now.toJSON();
    };
    DateTimeHelper.getTodayNoDate = function () {
        return new Date((this.getDateString(new Date())));
    };
    DateTimeHelper.getUtcNowOffsetted = function () {
        var now = new Date();
        return new Date(now.getTime() + now.getTimezoneOffset() * 60000).toJSON();
    };
    DateTimeHelper.getDateOffsetted = function (date) {
        return new Date(date.getTime() + (date.getTimezoneOffset() + (moment(date).isDST() ? 60 : 0)) * 60000).toJSON();
    };
    DateTimeHelper.getDateString = function (date) {
        var dateFromString;
        if (typeof date === "string") {
            dateFromString = new Date(date);
        }
        var dateValue = typeof date === "string" ? dateFromString : date;
        return dateValue.getFullYear() +
            "-" +
            (NumberUtilities.pad2(dateValue.getMonth() + 1)) +
            "-" +
            NumberUtilities.pad2(dateValue.getDate());
    };
    DateTimeHelper.getDateFormatted = function (value, format) {
        if (format === void 0) { format = "DD/MM/YYYY HH:mm"; }
        return moment(new Date(value)).format(format);
    };
    DateTimeHelper.getFormattedDate = function (date) {
        var dateStr = NumberUtilities.pad2(date.getDate()) + "/" +
            (NumberUtilities.pad2(date.getMonth() + 1)) +
            "/" + date.getFullYear();
        return dateStr;
    };
    return DateTimeHelper;
}());
export { DateTimeHelper };
